var Marionette = require('backbone.marionette');

var FaceToFaceFormsCollection = require('../../collections/face-to-face-form-collection');
var FaceToFaceFormModel = require('../../models/face-to-face-form-model');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');


var FaceToFaceFormItem = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/med-forms/face-to-face-item.html'),

    ui: {
        checkOrUncheck: '.check-ff-form',
        removeFaceToFaceForm: '.remove-face-to-face-form'
    },

    events: {
        'click @ui.checkOrUncheck': 'checkOrUncheck',
        'click @ui.removeFaceToFaceForm': 'remove'
    },

    templateContext: function () {
        var that = this;
        return {
            id: this.model.get("signed")
                ? "-"
                : '<a href = "/#ff-form/' + this.model.get("id") + '">Open</a>',
            faceToFaceDate: that.utils.longToDateTimeFormatted((this.model.get("data").faceToFaceDate), 'MM/DD/YYYY'),
            patient: this.model.get("patient")
                ? '<a href="/#person/' + this.model.get("patient").id + '" target="_blank">' + this.model.get("patient").name + '</a>'
                : "",
            reviewer: this.model.get("reviewer")
                ? '<a href="/#person/' + this.model.get("reviewer").id + '" target="_blank">' + this.model.get("reviewer").name + '</a>'
                : "",
            requestingOrg: this.model.get("requestingOrg")
                ? '<a href="/#organization/' + this.model.get("requestingOrg").id + '" target="_blank">' + this.model.get("requestingOrg").name + '</a>'
                : "",
            creator: this.model.get("createdBy")
                ? '<a href="/#person/' + this.model.get("createdBy").id + '" target="_blank">' + this.model.get("createdBy").name + '</a>'
                : "",
            isSigned: this.model.get("signed") ? "YES" : "NO",
            signedTime: this.model.get("signedTime") == 0
                ? ""
                : that.utils.longToDateTimeFormatted((this.model.get("signedTime")), 'MM/DD/YYYY hh:mm A'),
            signedDocumentId: this.model.get("signedDocumentId"),
            currentUserDo: this.currentUser == this.model.get("createdBy").id
        }
    },

    initialize: function (options) {
        this.utils = new CommonUtils();
        this.currentUser = options.currentUser
    },

    checkOrUncheck: function (event) {
        this.triggerMethod('row:selected', {
            ffFormId: this.model.get("id"),
            addOrRemove: event.target.checked
        });
    },
    remove: function(event) {
        this.triggerMethod('row:remove', {
            ffFormId: this.model.get("id")
        });
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(8), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});


var FaceToFaceFormsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: FaceToFaceFormItem,
    emptyView: EmptyView,

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {
        'row:selected': 'onFfFormRowSelected',
        'row:remove': 'onFfFormRowRemove'
    },

    initialize: function (options) {
        _.bindAll(this, 'showLoading', 'hideLoading', 'logError');
        this.collection = options.collection;
        this.currentUser = options.currentUser;
        this.formatDate = options.formatDate;
    },

    childViewOptions: function () {
        return {
            currentUser: this.currentUser,
            formatDate: this.formatDate
        };
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    onFfFormRowSelected: function (data) {
        this.triggerMethod('row:selected', data);
    },

    onFfFormRowRemove: function (data) {
        this.triggerMethod('row:remove', data);
    }
});

var FaceToFaceFormsListView = Marionette.View.extend({
    template: require('../../templates/med-forms/face-to-face-forms.html'),

    regions: {
        form: '#form',
        tableBody: {
            el: 'tbody',
            replaceElement: true
        }
    },

    ui: {
        checkOrUncheckAll: '#check-all',
        sortable: '.sortable'
    },

    events: {
        'click @ui.checkOrUncheckAll': 'checkOrUncheckAllPersons',
        'click @ui.sortable': 'reorder'
    },

    collectionEvents: {
        error: 'logError'
    },

    childViewEvents: {
        'row:selected': 'onFfFormRowSelected',
        'row:remove': 'onFfFormRowRemove'
    },

    templateContext: function () {
        var that = this;
        return {}
    },

    initialize: function (options) {
        this.model = new FaceToFaceFormModel();
        this.utils = new CommonUtils();
        this.currentUser = options.currentUser;
        this.ffFormsIds = [];

        this.tableFilterPreferences = {
            tableColumnFilters: [],
            sortField: "faceToFaceDate",
            sortDirection: "ASC"
        };
    },

    onErrors: function (model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    onRender: function () {
        window.document.title = "Face to face forms";
        var that = this;

        that.collection = new FaceToFaceFormsCollection([], {});

        that.showLoading();
        that.collection.fetch({
            success: function () {
                that.renderTable();
                that.hideLoading();
            },
            error: function () {
                that.hideLoading();
            }
        });
    },

    renderTable: function () {
        var that = this;
        this.tableBody = new FaceToFaceFormsTableBody({
            collection: that.collection,
            currentUser: that.currentUser,
            formatDate: function (dateAsLong) {
                return that.utils.longToDateTimeFormatted(dateAsLong, 'MMM DD YYYY');
            }
        });
        that.showChildView('tableBody', this.tableBody);
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    checkOrUncheckAllPersons: function (event) {
        var that = this;
        if (event.target.checked) {
            $('.check-ff-form').prop('checked', true);

            that.ffFormsIds = that.collection.map(function (model) {
                return model.get('id');
            });
        } else {
            that.ffFormsIds = [];
            $('.check-ff-form').prop('checked', false);
        }

        that.ffFormsIds = _.uniq(that.ffFormsIds);
    },

    onFfFormRowSelected: function (data) {
        var that = this;
        if (data.addOrRemove) {
            that.ffFormsIds.push(data.ffFormId);
        } else {
            that.ffFormsIds = (that.ffFormsIds || []).filter(function (id) {
                return id !== data.ffFormId
            });
        }

        that.ffFormsIds = _.uniq(that.ffFormsIds);
    },

    onFfFormRowRemove: function (data) {
        var that = this;
        var r = confirm("You are going to Remove this Face-to-Face Form. Are you sure?");
        if (r == true) {
            $.ajax({
                type: "DELETE",
                url: '/api/face-to-face-form/' + data.ffFormId,
                statusCode: {
                    200: function (response) {
                        $.notify("Removed successfully", "success");
                        that.onRender();
                    }
                },
                error: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            });
        } else {
            console.log("Cancel");
        }
    },

    reorder: function (event) {
        console.log(this.tableFilterPreferences);
        var that = this;
        var sortFieldName = $(event.target).next().attr("id");
        if (this.tableFilterPreferences.sortField == sortFieldName) {
            this.tableFilterPreferences.sortDirection = this.tableFilterPreferences.sortDirection == "ASC" ? "DESC" : "ASC";
        } else {
            this.tableFilterPreferences.sortField = sortFieldName;
            this.tableFilterPreferences.sortDirection = "ASC";
        }

        this.renderSortColumns();
        this.resort(this.collection);
        this.renderTable();
    },

    renderSortColumns: function () {
        var that = this;
        var sortField = that.tableFilterPreferences.sortField;
        var sortDirection = that.tableFilterPreferences.sortDirection;
        $('.sort-icon').removeClass("glyphicon glyphicon-triangle-top glyphicon-triangle-bottom");
        var currentSortEl = $("#" + sortField).parent().children(':first-child');

        if (sortDirection == "ASC") {
            currentSortEl.addClass("glyphicon glyphicon-triangle-top");
        } else {
            currentSortEl.addClass("glyphicon glyphicon-triangle-bottom");
        }
    },

    resort: function (collection) {
        collection.sortByFieldAndDirection(this.tableFilterPreferences.sortField, this.tableFilterPreferences.sortDirection);
    }
});


module.exports = FaceToFaceFormsListView;


//////////////////
// WEBPACK FOOTER
// ./app/views/med-forms/face-to-face-forms-view.js
// module id = 523
// module chunks = 0